import {IGridStatus} from '../../ap-interface/interfaces/ap-grid-status.interface';
import IGuid = System.IGuid;
import IFieldCrop = Data.FieldManagement.IFieldCrop;

export interface IPpOverviewGridItem {
  Id: IGuid;
  FieldCrop: IFieldCrop | null;
  Status: IGridStatus;
  Nr: number;
  SNr: number;
  NrSNr: string;
  Name: string;
  Area: number;
  Crop: string;
  EcValue: number;
  CropNote: string;
  Applications: IPpOverviewDetailsGridItem[];
}

export interface IPpOverviewDetailsGridItem {
  Id: IGuid;
  FieldId: IGuid;
  Status: IGridStatus;
  ApplNum: string;
  OperationMode: string;
  WorkArea: number;
  ApplDate: Date;
  Ec: number;
  NUptakeAvg: number;
  NUptakeMin: number;
  NUptakeMax: number;
  WaterAvg: number;
  WaterMin: number;
  WaterMax: number;
  Products: string;
  ProductsTooltip: string;
  CropKey: number;
  PlanId: string;
}

export enum PpColumnSwitchValue {
  Water,
  NUptake
}

export enum PpOverviewMassEditAction {
  Edit = 0
}
